export default "__VITE_ASSET__BTtjsPl9__"